"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _freeBrandsSvgIcons = require("@fortawesome/free-brands-svg-icons");
var Icon = function Icon(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, (0, _extends2["default"])({}, props, {
    icon: _freeSolidSvgIcons.fas[props.icon] || _freeBrandsSvgIcons.fab[props.icon],
    style: {
      color: "".concat(props.style)
    }
  }));
};
var _default = Icon;
exports["default"] = _default;